import { useRef, useEffect } from 'react'

export default function DashboardComponent() {
  const iframeRef = useRef(null)

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data?.type === 'NEXUS_EVENT') {
        console.log('Evento do dashboard:', event.data)
      }
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [])

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        ref={iframeRef}
        src="/dashboard/index.html"
        title="Nexus Analytics Studio"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
        allow="clipboard-write"
      />
    </div>
  )
}
